module.exports = __webpack_public_path__ + "img/book-4.2e924491.png";